type PricingPlan = {
    id: number;
    plan_name: string;
};

export enum ASSIGMENT_CODE {
    LOST_TICKET = 'CHARGE_PLAN_LOST_TICKET',
    LATE_EXIT = 'CHARGE_PLAN_LATE_EXIT',
    NO_FREE_TIME = 'CHARGE_PLAN_NO_FREE_TIME',
    VIP_OVER_STAY = 'CHARGE_PLAN_V_P_OVER_STAY',
}

type Assignment = {
    code: ASSIGMENT_CODE;
    planId: number;
};
type ThirdPeriod = {
    price_tick: number;
    due_amount: number;
};

type Period = {
    duration: number;
} & ThirdPeriod;

type SpecialPeriod = {
    in_use: boolean;
    period_start: number;
    period_end: number;
} & ThirdPeriod;

export enum TIME_TO_LEAVE_OPTIONS {
    'NORMAL' = 'NORMAL',
    'FIXED_HOUR' = 'FIXED_HOUR',
}

type PricingPlanDetails = {
    id: number;
    plan_name: string;
    initial_price: number;
    free_time: number;
    first_period: Period[];
    second_period: Period[];
    third_period: ThirdPeriod[];
    special_period: SpecialPeriod[];
    vat: number;
    time_to_leave: number;
    time_to_leave_option: TIME_TO_LEAVE_OPTIONS;
    optional_plan_id?: number;
};

type PricingPlanPoint = {
    id: string;
    price_plan_id: number;
    price_plan_name: string;
};
export type { PricingPlan, Assignment, PricingPlanDetails, PricingPlanPoint };
